import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, AlertCircle, MailCheck } from 'lucide-react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrapper from '../components/PageWrapper';
import SEOMeta from '../components/SEOMeta';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? `${window.location.protocol}//${window.location.hostname}:8001`;

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | ok | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Enlace de verificación incompleto.');
      return;
    }
    axios.post(`${BACKEND_URL}/api/auth/verify-email`, { token })
      .then(() => setStatus('ok'))
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'El enlace no es válido o ha caducado.');
      });
  }, [token]);

  return (
    <PageWrapper scrollable>
      <SEOMeta title="Verificar correo" noIndex />
      <Navbar />
      <main className="register-main anim-fade-up" style={{ animationDelay: '0.2s' }}>
        <div className="register-card" style={{ textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <MailCheck size={52} style={{ margin: '0 auto 16px', color: '#22d3ee' }} />
              <h2 className="register-title">Verificando tu correo…</h2>
            </>
          )}
          {status === 'ok' && (
            <>
              <CheckCircle size={52} className="success-icon" style={{ margin: '0 auto 16px' }} />
              <h2 className="register-title">Correo verificado</h2>
              <p className="register-subtitle" style={{ marginTop: 8 }}>
                Tu cuenta ya está confirmada. Si tienes un referido pendiente, sus cristales se concederán
                automáticamente cuando alcance nivel 20.
              </p>
              <Link to="/cuenta" className="register-btn" style={{ display: 'inline-block', marginTop: 24, textAlign: 'center' }}>
                Ir a mi cuenta
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <AlertCircle size={52} style={{ margin: '0 auto 16px', color: '#f87171' }} />
              <h2 className="register-title">No se pudo verificar</h2>
              <p className="register-subtitle" style={{ marginTop: 8 }}>{message}</p>
              <Link to="/cuenta" className="terms-link" style={{ display: 'block', marginTop: 24, fontSize: 13 }}>
                Ir a mi cuenta para reenviar el correo de verificación
              </Link>
            </>
          )}
        </div>
      </main>
      <Footer />
    </PageWrapper>
  );
}
